import { AfterViewInit, Directive, HostListener, ViewChild } from '@angular/core';
import { NgxMasonryComponent, NgxMasonryOptions } from 'ngx-masonry';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';

import { featuresWithPermissions } from './../data/permissions';

@Directive()
export abstract class MasonryBaseComponent extends BaseComponent implements AfterViewInit {
    public myOptions: NgxMasonryOptions = {
        gutter: 15,
        columnWidth: 400,
        itemSelector: '.masonry-item',
    };

    public columnMasonryWidth = '15px';

    public permissions = featuresWithPermissions;

    @ViewChild(NgxMasonryComponent) public masonry: NgxMasonryComponent;

    @HostListener('window:resize')
    public onresize(): void {
        if (window.innerWidth <= 768) {
            this.updateColumnWidth();
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.reloadView();
        }, 0);
    }

    public reloadView(): void {
        if (this.masonry) {
            this.masonry.reloadItems();
            this.masonry.layout();
        }
    }

    public updateWidthGutter(e: any): void {
        if (e && e[0]) {
            this.columnMasonryWidth = 15 * (e[0].layout.cols + 1) + 'px';
        }
    }

    private updateColumnWidth(): void {
        this.myOptions = {
            ...this.myOptions,
            columnWidth: 'auto',
        };
    }
}
